var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCleanService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H17V9.2C17 10.8802 17 11.7202 16.673 12.362C16.3854 12.9265 15.9265 13.3854 15.362 13.673C14.7202 14 13.8802 14 12.2 14H5.8C4.11984 14 3.27976 14 2.63803 13.673C2.07354 13.3854 1.6146 12.9265 1.32698 12.362C1 11.7202 1 10.8802 1 9.2V9Z",
    fill: "#F3E5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9V2.6C17 2.03995 17 1.75992 16.891 1.54601C16.7951 1.35785 16.6422 1.20487 16.454 1.10899C16.2401 1 15.9601 1 15.4 1H2.6C2.03995 1 1.75992 1 1.54601 1.10899C1.35785 1.20487 1.20487 1.35785 1.10899 1.54601C1 1.75992 1 2.03995 1 2.6V9M17 9H1M17 9V9.2C17 10.8802 17 11.7202 16.673 12.362C16.3854 12.9265 15.9265 13.3854 15.362 13.673C14.7202 14 13.8802 14 12.2 14H5.8C4.11984 14 3.27976 14 2.63803 13.673C2.07354 13.3854 1.6146 12.9265 1.32698 12.362C1 11.7202 1 10.8802 1 9.2V9M11.5 14V18.5C11.5 19.8807 10.3807 21 9 21C7.61929 21 6.5 19.8807 6.5 18.5V14",
    stroke: "#6A1B9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanService);
export default __webpack_public_path__ + "static/media/cleanService.22efc5d1cf088a9f4080be091fc7c20d.svg";
export { ForwardRef as ReactComponent };